import type { EventFilter, TelemetryEvent } from './types';

const FILTERED = '[Filtered]';
const TOKEN_IN_STRING = /("?authorization"?\s*:\s*)("[^"]*"|'[^']*'|(?:(?:Bearer|Basic)\s+)?[^,}\s]+)/gi;

/** Replaces authorization token values in free-form strings (e.g. error messages) with `[Filtered]`. */
export function redactAuthTokens(text: string): string {
  return text.replace(TOKEN_IN_STRING, (_match, prefix: string, value: string) => {
    const quote = value.startsWith('"') ? '"' : value.startsWith('\'') ? '\'' : '';
    return `${prefix}${quote}${FILTERED}${quote}`;
  });
}

/** Redacts auth tokens in `error.message`/`error.stack` of `type === 'error'` events, in place; never drops. */
export function redactErrorStrings<T extends TelemetryEvent>(): EventFilter<T> {
  return (event) => {
    if (event.type !== 'error' || !event.error) return true;
    if (event.error.message) event.error.message = redactAuthTokens(event.error.message);
    if (event.error.stack) event.error.stack = redactAuthTokens(event.error.stack);
    return true;
  };
}
